export default "/images/7493b4e6b224a06ce959a96398bdc563.avif";